import black from './black.js';
import white from './white.js';
import { ThemeType } from '@/constant/theme';
import { computed } from 'vue';

import { currentTheme as layoutCurrentTheme, setTheme as layoutSetTheme } from 'vue-layout-gitcode';

const themeColorMap = {
  [ThemeType.BLACK]: black,
  [ThemeType.WHITE]: white
};
export const themeColor = computed(() => {
  return themeColorMap[currentTheme.value];
});

export const currentTheme = layoutCurrentTheme;

export const setTheme = (theme) => {
  layoutSetTheme(theme);
};

class Theme {
  constructor() {
    this.darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  }

  getIsAutoTheme() {
    return localStorage.getItem('AutoTheme') === 'AUTO';
  }

  applyTheme() {
    const isAutoTheme = this.getIsAutoTheme();
    if (!isAutoTheme) return;
    if (this.darkModeMediaQuery.matches) {
      console.log('dark');
      setTheme(ThemeType.BLACK);
    } else {
      console.log('light');
      setTheme(ThemeType.WHITE);
    }
  }

  initAutoTheme() {
    // 用户没有设置主题
    const defaultTheme = localStorage.getItem('gitcode_theme');
    if (!defaultTheme) {
      this.startAutoTheme();
      return;
    }

    const defaultAutoTheme = this.getIsAutoTheme();
    if (defaultAutoTheme) {
      this.startAutoTheme(true);
    } else {
      this.stopAutoTheme(true);
    }
  }

  startAutoTheme(isInit = false) {
    if (!isInit) {
      localStorage.setItem('AutoTheme', 'AUTO');
    }
    this.darkModeMediaQuery.onchange = () => this.applyTheme(); // 添加监听器以处理颜色方案变化
    this.applyTheme();
  }

  stopAutoTheme(isInit = false) {
    if (!isInit) {
      localStorage.removeItem('AutoTheme');
    }
    this.darkModeMediaQuery.onchange = null;
  }
}

export const theme = new Theme();
